(() => {
  const getNodes = () => {
    const overlay = document.querySelector('[data-global-video-overlay]');
    const frame = overlay?.querySelector('[data-global-video-frame]');
    return { overlay, frame };
  };

  const toEmbedUrl = (url) => {
    if (!url) return null;
    try {
      const parsed = new URL(url, window.location.origin);
      const host = parsed.hostname.replace('www.', '');
      if (host.includes('youtube.com')) {
        const id = parsed.searchParams.get('v');
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : null;
      }
      if (host.includes('youtu.be')) {
        const id = parsed.pathname.split('/').filter(Boolean)[0];
        return id ? `https://www.youtube.com/embed/${id}?autoplay=1&rel=0` : null;
      }
      if (host.includes('vimeo.com')) {
        const id = parsed.pathname.split('/').filter(Boolean)[0];
        return id ? `https://player.vimeo.com/video/${id}?autoplay=1` : null;
      }
    } catch (error) {}
    return null;
  };

  const normalizeUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('//')) return `https:${url}`;
    return url;
  };

  const clear = (frame) => {
    frame.innerHTML = '';
  };

  const close = () => {
    const { overlay, frame } = getNodes();
    if (!overlay || !frame) return;
    clear(frame);
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  };

  const open = (url, mime = '') => {
    const { overlay, frame } = getNodes();
    if (!overlay || !frame || !url) return;

    const normalizedUrl = normalizeUrl(url);
    clear(frame);

    const embed = toEmbedUrl(normalizedUrl);
    if (embed) {
      const iframe = document.createElement('iframe');
      iframe.src = embed;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.allowFullscreen = true;
      frame.appendChild(iframe);
    } else {
      const video = document.createElement('video');
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'auto';
      video.src = normalizedUrl;
      frame.appendChild(video);
      const playAttempt = video.play();
      if (playAttempt && typeof playAttempt.catch === 'function') {
        playAttempt.catch(() => {});
      }
    }

    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  };

  const handleTriggerClick = (event) => {
    const trigger = event.target.closest('[data-global-video-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const url = trigger.getAttribute('data-video-url');
    const mime = trigger.getAttribute('data-video-mime') || '';
    if (url) open(url, mime);
  };

  const handleCloseClick = (event) => {
    if (event.target.closest('[data-global-video-close]')) {
      event.preventDefault();
      close();
    }
  };

  const handleKeydown = (event) => {
    const { overlay } = getNodes();
    if (event.key === 'Escape' && overlay && !overlay.hidden) close();
  };

  const init = () => {
    if (!getNodes().overlay) return false;
    if (window.__jaafitGlobalVideoOverlayReady) return true;

    window.__jaafitGlobalVideoOverlayReady = true;
    document.addEventListener('click', handleTriggerClick, true);
    document.addEventListener('click', handleCloseClick);
    document.addEventListener('keydown', handleKeydown);
    return true;
  };

  window.JaafitVideoOverlay = { open, close };

  if (!init()) {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  }
})();
